import { apiHandler } from '@/services/apiHandler';
import { lotteShoppingAxios } from '@/services/axiosInstances';
import { FNB_ENDPOINTS } from '@/services/endpoints';
import type { FnbReviewResponse } from '@/services/dto';
import type { ApiResponse } from '@/types/api';

export const getFnbReviewList = async (cstrShopNo: string): Promise<ApiResponse<FnbReviewResponse>> => {
    return apiHandler(async () => {
        const headerConfig = {
            'Content-Type': 'application/json',
            apiId: import.meta.env.VITE_LOTTE_API_APP_ID_EIF_APP_021,
            apiAthrKey: import.meta.env.VITE_LOTTE_API_ATHR_KEY_EIF_APP_021,
            apiUsprKey: import.meta.env.VITE_LOTTE_API_USPR_KEY_EIF_APP_021,
        };

        const response: FnbReviewResponse = await lotteShoppingAxios.get(`${FNB_ENDPOINTS.GET_REVIEW_LIST}/${cstrShopNo}`, {
            headers: headerConfig,
        });

        return response;
    });
};
